import React, { FunctionComponent } from "react";
import { Plan, DetailItemProps } from "../../../@types";
import {
  getBenefitCost,
  useTranslate,
  hasSomeDentalCoverage,
  shouldSuppressPlanBenefits,
} from "../../../helpers";
import CDI from "./ComparisonDetailItem";

const ExtraBenefits: FunctionComponent<{ plan: Plan }> = ({ plan }) => {
  const t = useTranslate();
  const suppressed = shouldSuppressPlanBenefits(plan);
  const ComparisonDetailItem: React.FunctionComponent<DetailItemProps> = props => {
    const extendedProps = { ...props, suppressed };
    return <CDI {...extendedProps} />;
  };

  const someDentalCoverage = hasSomeDentalCoverage(t, plan);

  return (
    <div className="columnSection columnSection__wrap">
      {/* Hearing aids */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.hearing_aids")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "hearing",
            service: "hearing_aids",
          })}
        />
      </div>

      {/* Preventive dental */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.preventive_dental")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "preventive_dental",
            service: "oral_exam",
          })}
        />
      </div>

      {/* Comprehensive dental */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.comprehensive_dental")}
          detail={
            someDentalCoverage
              ? t("some_coverage")
              : t("plan_terms.not_covered")
          }
        />
      </div>

      {/* Eyeglasses */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.vision.eyeglasses")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "vision",
            service: "eyeglasses_frames_and_lenses",
          })}
        />
      </div>

      {/* Wellness programs */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.wellness_programs")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "wellness_programs",
          })}
        />
      </div>

      {/* Transportation */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.transportation")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "transportation",
          })}
        />
      </div>

      {/* Skilled nursing facility */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.skilled_nursing_facility")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "skilled_nursing_facility",
          })}
        />
      </div>

      {/* Durable medical equipment */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.medical_equipment.durable_medical_equipment")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "medical_equipment",
            service: "durable_medical_equipment",
          })}
        />
      </div>

      {/* Diabetic supplies */}
      <div className="planCompare__cell">
        <ComparisonDetailItem
          mobileLabelOnly
          label={t("plan_terms.medical_equipment.diabetes_supplies")}
          detail={getBenefitCost(t, {
            plan,
            benefit: "medical_equipment",
            service: "diabetes_supplies",
          })}
        />
      </div>
    </div>
  );
};

export default ExtraBenefits;
